import semisData from './shared/state';

export default {
  modules: {
    semisData,
  },
};
